<template>
  <sdz-modal
    ref="sdzModal"
    @close="close"
    :title="modalTitle"
    @saveConfiguration="saveConfiguration"
    @cancelConfiguration="cancelConfiguration"
    confirm-button-label="Salvar"
    confirmation-event="saveConfiguration"
    cancel-event="cancelConfiguration"
    width="550"
    persistent
    custom-class="default-sheet-modal"
    buttons-position="right"
    close-icon
  >
    <template>
      <div class="content">
        <p>
          Realize a configuração das colunas que serão exibidas no<br>
          template e defina quais campos são obrigatórios durante o<br>
          preenchimento.
          <br>
          <br>
          As colunas desabilitadas não poderão ser alteradas.
        </p>
        <div class="options">
          <span>Colunas</span>
          <span>Tornar obrigatório</span>
        </div>
        <div
          v-for="(option, index) in sheetOptions"
          :key="index"
          class="list-content"
        >
          <AppCheckBox
            v-model="option.checkbox"
            :options="[{ title: option.label, value: false}]"
            @input="setCheckboxValue(option)"
            :disabled="!option.editable"
          />
          <AppSwitch
            v-model="option.switch"
            @change="setSwitchValue(option)"
            :disabled="!option.editable"
          />
        </div>
      </div>
    </template>
  </sdz-modal>
</template>

<script>
  import AppCheckBox from '@/components/ui/inputs/AppCheckBox.vue'
  import AppSwitch from '@/components/ui/inputs/AppSwitch'
  import { getSellOutSpreadSheetField } from '@/services/containers/partners/campaigns'
  import { cloneDeep } from 'lodash'

  export default {
    name: 'DefaultPartnerSheetModal',

    components: {
      AppCheckBox,
      AppSwitch,
      SdzModal: () => import('@/components/sdz/SdzModal.vue')
    },

    props: {
      form: {
        type: Object,
        default: () => {},
      }
    },

    data: () => ({
      sheetOptions: [],
      insertedFields: []
    }),

    created() {
      this.fetchSellOutSpreadSheetField()
      this.insertedFields = cloneDeep(this.form?.sellOutSpreadsheetFields)
    },

    computed: {
      modalTitle() {
        return 'Configurar planilha padrão do parceiro'
      }
    },

    methods: {
      async fetchSellOutSpreadSheetField() {
        try {
          const { data } = await getSellOutSpreadSheetField()
          const dataOptions = data.map(e => {
            const option = this.form?.sellOutSpreadsheetFields.find(field => field.columnName === e.columnName)
            return option
            ? {
                ...option,
                checkbox: true,
                defaultValueRequired: false,
                editable: !e?.defaultValueRequired,
                label: option.columnName,
                switch: option?.required
              }
            : {
                ...e,
                checkbox: e.defaultValueRequired,
                switch: e.defaultValueRequired
              }
          })
          this.sheetOptions = [...dataOptions]
        } catch (error) {
          // console.log(error)
        }
      },
      open() {
        this.$refs.sdzModal.show = true
      },
      close() {
        this.$refs.sdzModal.show = false
      },
      cancelConfiguration() {
        this.form.sellOutSpreadsheetFields = this.insertedFields
        this.fetchSellOutSpreadSheetField()
        this.close()
      },
      saveConfiguration() {
        this.insertedFields = this.form.sellOutSpreadsheetFields
        this.close()
      },
      findFieldByColumnName(fields, columnName) {
        return fields.find(field => field.columnName === columnName)
      },
      setSwitchValue(option, remove = false) {
        const { columnName, switch: switchValue } = option
        if (remove) {
          const sheetOption = this.findFieldByColumnName(this.sheetOptions, columnName)
          if (sheetOption) {
            sheetOption.switch = false
          }
        }
        const spreadsheetField = this.findFieldByColumnName(this.form.sellOutSpreadsheetFields, columnName)
        if (spreadsheetField) {
          spreadsheetField.required = switchValue
        } else {
          this.findFieldByColumnName(this.sheetOptions, columnName).checkbox = true
          const requiredOption = this.findFieldByColumnName(this.sheetOptions, columnName)
          this.setCheckboxValue(requiredOption)
        }
      },
      setCheckboxValue(option) {
        const { columnName, checkbox, switch: switchValue } = option
        if (checkbox) {
          this.form.sellOutSpreadsheetFields = [
            { columnName, required: switchValue },
            ...this.form.sellOutSpreadsheetFields,
          ]
        } else {
          this.setSwitchValue(option, true)
          this.form.sellOutSpreadsheetFields = this.form.sellOutSpreadsheetFields
            .filter(field => field.columnName !== columnName)
        }
      },
    }
  }
</script>

<style lang="stylus">
  .default-sheet-modal {
    .content {
      padding: 20px;
      p {
        font-size: 16px;
      }
      .options {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        margin-top: 5px;
        margin: 30px 0;
      }
      .list-content {
        display: flex;
        .layout {
          display: flex;
          flex-direction: column;
          .v-input__control {
            width: 100%;
          }
        }
        .app-switch, .app-checkbox {
          .v-input__slot {
            margin-top: -30px;
            background-color: var(--neutral-low-light);
            padding: 5px 10px;
          }
        }
        .app-switch {
          .v-input__slot {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            border: 1px var(--neutral-low-dark) solid;
            border-left: none;
          }
        }
        .app-checkbox {
          .v-input__slot {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            border: 1px var(--neutral-low-dark) solid;
            border-right: none;
          }
        }
      }
    }
  }
</style>
